export var Ppt;
(function (Ppt) {
    var SlideTileEventType;
    (function (SlideTileEventType) {
        SlideTileEventType[SlideTileEventType["Undefined"] = 0] = "Undefined";
        SlideTileEventType[SlideTileEventType["Delete"] = 1] = "Delete";
        SlideTileEventType[SlideTileEventType["Add"] = 2] = "Add";
        SlideTileEventType[SlideTileEventType["Change"] = 3] = "Change";
        SlideTileEventType[SlideTileEventType["Refresh"] = 4] = "Refresh";
    })(SlideTileEventType = Ppt.SlideTileEventType || (Ppt.SlideTileEventType = {}));
})(Ppt || (Ppt = {}));
//# sourceMappingURL=powerpoint-schemas.js.map